"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducerNamespace = exports.default = void 0;

var _redux = require("redux");

var _reducer = _interopRequireDefault(require("settings-content-modals/EmailCreationModal/Auth/reducer"));

var _reducer2 = _interopRequireDefault(require("settings-content-modals/EmailCreationModal/PortalSettings/reducer"));

var _reducer3 = _interopRequireDefault(require("settings-content-modals/EmailCreationModal/RequestStatuses/reducer"));

var _reducer4 = _interopRequireDefault(require("settings-content-modals/EmailCreationModal/SubscriptionEmails/reducer"));

var _portalDragAndDropAvailable = _interopRequireDefault(require("EmailData/reducers/portalDragAndDropAvailable"));

var _reducer5 = _interopRequireDefault(require("settings-content-modals/EmailCreationModal/modalInteractions/reducer"));

var _default = (0, _redux.combineReducers)({
  auth: _reducer.default,
  portalSettings: _reducer2.default,
  requests: _reducer3.default,
  subscriptionEmails: _reducer4.default,
  portalDragAndDropAvailable: _portalDragAndDropAvailable.default,
  interactions: _reducer5.default
});

exports.default = _default;
var reducerNamespace = 'email-creation-modal';
exports.reducerNamespace = reducerNamespace;